import is from '@sindresorhus/is';
import type { QueryClient, QueryKey } from '@tanstack/react-query';

import type { JobLevel } from '~/shared/data-contract/job-level';
import type { JobLevelDetails } from '~/shared/data-contract/job-level-details';

import { jobArchitectureKeys } from '../query-keys';

export const updateLevelReviewerData = (item: JobLevel | JobLevelDetails, queryClient: QueryClient): void => {
    const levelQueriesData = queryClient.getQueriesData({
        queryKey: jobArchitectureKeys.level(item.architectureId, item.id),
    });

    levelQueriesData.forEach(([queryKey, data]: [QueryKey, JobLevelDetails]) => {
        if (!is.undefined(data) && !is.undefined(data.jobProfile)) {
            queryClient.setQueryData(queryKey, {
                ...data,
                reviewer: item.reviewer,
            });
        }
    });

    queryClient.setQueryData(
        jobArchitectureKeys.levelsByRole(item.architectureId, item.parentId ?? ''),
        (old: JobLevelDetails[]) => {
            return old?.map((level) => {
                if (level.id === item.id) {
                    return {
                        ...level,
                        reviewer: item.reviewer,
                    };
                }

                return level;
            });
        },
    );
};

export const updateRoleReviewerData = (
    item: {
        readonly id: string;
        readonly architectureId: string;
        readonly parentId?: string | null;
        readonly reviewer?: unknown;
    },
    queryClient: QueryClient,
): void => {
    const roleQueriesData = queryClient.getQueriesData({
        queryKey: jobArchitectureKeys.roles(item.architectureId),
    });

    roleQueriesData.forEach(
        ([queryKey, data]: [
            QueryKey,
            { readonly id?: string; readonly jobProfile?: unknown; readonly reviewer?: unknown },
        ]) => {
            if (!is.undefined(data) && data.id === item.id && !is.undefined(data.jobProfile)) {
                queryClient.setQueryData(queryKey, {
                    ...data,
                    reviewer: item.reviewer,
                });
            }
        },
    );

    queryClient.setQueryData(
        jobArchitectureKeys.rolesByCluster(item.architectureId, item.parentId ?? ''),
        (old: readonly { readonly id: string; readonly reviewer?: unknown }[] | undefined) => {
            return old?.map((role) => {
                if (role.id === item.id) {
                    return {
                        ...role,
                        reviewer: item.reviewer,
                    };
                }

                return role;
            });
        },
    );
};
